import { createAuthClient } from "better-auth/react";
import { magicLinkClient } from "better-auth/client/plugins";

/** Same origin: the API serves /api/auth in production; Vite proxies it in development. */
export const authClient = createAuthClient({ basePath: "/api/auth", plugins: [magicLinkClient()] });
